import { render, staticRenderFns } from "./NewFileModal.vue?vue&type=template&id=4fd24b77&scoped=true"
import script from "./NewFileModal.vue?vue&type=script&lang=js"
export * from "./NewFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd24b77",
  null
  
)

export default component.exports